export default {
  title: 'Articles',
};
